/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from "react";
import LayoutOperation from "../../../components/layout_operation";
import BusDetailPanel from "./bus_detail_panel/BusDetailPanel";
import { Collapse } from "antd";
import Cookies from "js-cookie";
import BusDetailModal from "./bus_detail_modal/BusDetailModal";

import AssetDetailPanel from "./asset_detail_panel/AssetDetailPanel";
import AdvertisingSchedulePanel from "./advertising_schedule_panel/AdvertisingSchedulePanel";
import Api from "../../../services/ServiceApi";
const { Panel } = Collapse;
const BusDetail = () => {
  const [isBusModalVisible, setBusModalVisible] = useState(false);
  const [busDetailData, setBusDatailData] = useState({});
  const [assetDetailData, setAssetDetailData] = useState({});
  let selectedBusID 
  if(Cookies.get('selected_bus_id') !== null){
    selectedBusID = JSON.parse(Cookies.get("selected_bus_id"))
  }
  useEffect(() => {
    Api.post("getDetailBus", {
      bus_id: selectedBusID,
    }).then((res) => {
      const data = res.data.data;
      const tempData = {
        busNO: data.bus_no,
        lineNO: data.bus_line_name,
        plateNO: data.license_plate,
      };
      setBusDatailData(res.data.data);
      setAssetDetailData(tempData);
    });
  }, {});
  return (
    <LayoutOperation active={3}>
      <div className="wrapper-header" style={{ height: "284px" }}>
        <div className="container-fluid">
          <div className="d-flex justify-content-between mb-2">
            {/* <Link className="font-thai-r fs-20 c-white" to="/ma_list">
              <i className="fas fa-chevron-left"></i>
              <span style={{ marginLeft: "5px", marginBottom: "20px" }}>
                Back
              </span>
            </Link> */}
          </div>
          {/* Bus data display*/}
          <div className="row">
            <div className="col-md-6">
              <div className="d-flex">
                <div className="mr-3 pt-2">
                  <img src={Api.absoluteUrl("/icon/name_job.svg")} />
                </div>
                <div>
                  <h2 className="font-thai-b fs-40 c-white mb-0">
                    Plate No.{busDetailData.license_plate}
                  </h2>
                  <span className="font-thai-i fs-20 c-white">
                    {busDetailData.bus_line_name} / Area {busDetailData.area_name} / Model {busDetailData.model_name}
                  </span>
                  <div className="mt-2">
                    {busDetailData.status_avaliable === "NOT AVAILABLE" ? 
                    <span className="badge badge-pill badge-danger font-thai-b fs-14 mr-2">
                    {busDetailData.status_avaliable}
                  </span>:
                    <span className="badge badge-pill badge-success font-thai-b fs-14 mr-2">
                    {busDetailData.status_avaliable}
                  </span> }
                    
                    <span className="badge badge-pill badge-light font-thai-b fs-14 mr-2">
                      Booking
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6">
            {  parseInt(localStorage.getItem("permission"))  === 1 ? 
              <a
                href="#"
                className="btn btn-warning"
                onClick={() => setBusModalVisible(true)}
                style={{ marginRight: "2vw", float: "right" }}
              >
                <img
                  src={Api.absoluteUrl("/icon/icon_edit.svg")}
                  width="14"
                  className="mr-2"
                />
                <span>Edit</span>
              </a>
              : null }
              {isBusModalVisible ? (
                <BusDetailModal handleVisible={setBusModalVisible} />
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="wrapper-body">
            <div className="container-fluid">
              <div className="row">
                <div className="col-4">
                  {/* Asset detail panel*/}
                  <AssetDetailPanel data={assetDetailData} />
                </div>
                {/* Bus detail panel */}
                <div className="col-8">
                  {/* Asset detail panel*/}
                  <Collapse expandIconPosition="right" defaultActiveKey={["1"]}>
                    <Panel
                      header={
                        <div>
                          <img
                            src={Api.absoluteUrl("/icon/asset_detail.svg")}
                            className="mr-3"
                            alt="asset detail icon"
                          />
                          <span className="c-blue text-uppercase">
                            <span className="c-blue text-uppercase">
                              Bus Detail
                            </span>
                          </span>
                        </div>
                      }
                      key="1"
                    >
                      <BusDetailPanel busDetailData={busDetailData} />
                    </Panel>
                  </Collapse>
                </div>
                {/* Advertising schedule */}
                <div className="row" style={{ width: "100%" }}>
                  <div className="col-12">
                    <Collapse
                      expandIconPosition="right"
                      defaultActiveKey={["1"]}
                    >
                      <Panel
                        header={
                          <div>
                            <img
                              src={Api.absoluteUrl("/icon/asset_detail.svg")}
                              className="mr-3"
                              alt="asset detail icon"
                            />
                            <span className="c-blue text-uppercase">
                              <span className="c-blue text-uppercase">
                                Advertising schedule
                              </span>
                            </span>
                          </div>
                        }
                        key="1"
                      >
                        <div className="col-12">
                          <AdvertisingSchedulePanel />
                        </div>
                      </Panel>
                    </Collapse>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutOperation>
  );
};

export default BusDetail;
